module.exports = __webpack_public_path__ + "media/images/icons/social/pinterest-2919d68c03d923f3941c2f3799de1e74724b47dc3ffbbb57f3943f0dceea2eed.svg";